import React from 'react';
import CompaniesList from '../components/CompaniesList';
import usePageMeta from '../hooks/usePageMeta';
import useHotjar from '../hooks/useHotjar';

function Companies() {
  usePageMeta({
    title: 'Companies',
    description: 'Browse companies in the Risqly network and explore cybersecurity posture visibility.',
  });
  useHotjar();

  return <CompaniesList />;
}

export default Companies;
